module.exports = __webpack_public_path__ + "static/media/chime.bbe08d2c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/chime.mp3
// module id = 809
// module chunks = 0